import React from 'react';
import { CSSZAddress } from '../../../Interfaces/CSSZ.interface';
import styles from './CSSZAddressPreview.module.scss';
import Text from '../../../../../Components/Base/Text/Text';
import { formatCSSZAddress } from '../../../Helpers/CSSZ.helper';

interface Props {
	address: CSSZAddress;
}

const CSSZAddressPreview: React.FC<Props> = ({ address }) => {
	return (
		<div className={styles.items}>
			<div>
				{address.typeOfAddress && (
					<Text
						className={styles.smallerText}
						tx={address.typeOfAddress.label}
					/>
				)}
				<Text className={styles.address} tx={formatCSSZAddress(address)} />
			</div>
			<div className={styles.extraInfo}>
				{address.floor && (
					<Text
						className={styles.smallerText}
						tx='component.CSSZSickLeaveCertificateFormPartB.floor'
						txParams={{ floor: address.floor }}
					/>
				)}
				{address.note && (
					<Text
						className={styles.smallerText}
						tx='component.CSSZSickLeaveCertificateFormPartB.note'
						txParams={{ note: address.note }}
					/>
				)}
			</div>
		</div>
	);
};

export default CSSZAddressPreview;
